<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div v-else>

      <!-- 背景音乐 -->
      <K-Music :Music="datas.music"></K-Music>
      <header>
        <div class="swiper-container banner">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-if="banner && datas.focus_pics_is_show == 1" v-for="(item, index) in banner"
              v-bind:key="index"><img :src="'../../static/images/Normal04/' + item"></div>
          </div>
        </div>
      </header>

      <section class="box">

        <div class="MainOidBox">
          <ul>
            <li>国家OID注册中心</li>
            <li class="MainOid">
              <i v-if="datas.business.company_idcode" v-text="datas.business.company_idcode"></i>
              <i v-else>1.2.156.40000.{{ datas.business.rootid }}</i>
            </li>
            <li>工信部授权的标识体系，全球可查验</li>
          </ul>
        </div>

        <!-- 焦点图 -->
        <div class="MainBox" v-if="datas.focus && datas.prod_is_show == 1">
          <viewer @inited="inited" ref="viewer">
            <div class="swiper-container bannerbox">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-if="datas.focus && datas.focus_pics_is_show == 1"
                  v-for="(item, index) in datas.focus" v-bind:key="index"><img :src="item.img"></div>
              </div>
            </div>
          </viewer>
        </div>

        <!-- 地图 -->
        <div class="MainBox" v-if="location">
          <div class="box-three" id="map"></div>
        </div>

        <!-- 产品信息 -->
        <div class="MainBox" v-if="datas.product && datas.prod_is_show == 1">
          <div class="MainTitle">产品信息</div>
          <div class="MainDatasBox">
            <div><img class="proimg" :src="datas.product.img" /></div>
            <ul class="MainData" v-if="datas.prod_name_is_show == 1">
              <li class="MainDataLeft">品名</li>
              <li class="MainDataRight" v-text="datas.product.name"></li>
            </ul>
            <ul class="MainData" v-if="datas.product.period && datas.prod_name_is_show == 1">
              <li class="MainDataLeft">保质期</li>
              <li class="MainDataRight" v-text="datas.product.period"></li>
            </ul>
            <ul class="MainData" v-if="datas.product.unit && datas.prod_name_is_show == 1">
              <li class="MainDataLeft">规格</li>
              <li class="MainDataRight" v-text="datas.product.unit"></li>
            </ul>
            <ul class="MainData" v-if="datas.product.introduce && datas.prod_name_is_show == 1">
              <li class="MainDataLeft">介绍</li>
              <li class="MainDataRight" v-text="datas.product.introduce"></li>
            </ul>
            <ul class="MainData" v-if="datas.attribute && datas.attribute.ship_date">
              <li class="MainDataLeft">生产日期</li>
              <li class="MainDataRight" v-text="datas.attribute.ship_date"></li>
            </ul>
            <ul class="MainData" v-if="datas.product.attribute" v-for="val in datas.product.attribute">
              <li class="MainDataLeft" v-text="val.key"></li>
              <li class="MainDataRight" v-text="val.value"></li>
            </ul>
          </div>
        </div>

        <!-- 防伪验证 -->
        <div class="MainBox" v-if="datas.verify">
          <div class="MainTitle">防伪验证</div>
          <div class="MainDatasBox">
            <p class="inputBox">
              <a class="inputBoxMain"><input @keyup.enter="CodeVerify" type="text" v-model="vcode" placeholder="请在这里输入防伪码" /></a>
              <i class="queryIcon" @click="CodeVerify"><img src="../../static/images/query-01.png"></i>
            </p>
          </div>
        </div>

        <!-- 商户信息 -->
        <viewer @inited="inited" ref="viewer">
          <div id="business-box" class="MainBox" v-if="datas.business && datas.business_is_show == 1">
            <div class="MainTitle">商户信息</div>
            <div class="MainDatasBox">
              <ul class="MainData">
                <li class="MainDataLeft">商户名称</li>
                <li class="MainDataRight" v-text="datas.business.name"></li>
              </ul>
              <ul class="MainData">
                <li class="MainDataLeft">联 系 人</li>
                <li class="MainDataRight" v-text="datas.business.linkman"></li>
              </ul>
              <ul class="MainData">
                <li class="MainDataLeft">联系方式</li>
                <li class="MainDataRight" v-text="datas.business.linkphone"></li>
              </ul>
              <ul class="MainData" v-if="datas.business.baddress">
                <li class="MainDataLeft">商户地址</li>
                <li class="MainDataRight" v-text="datas.business.baddress"></li>
              </ul>
              <ul class="MainData" v-if="datas.business.baddress">
                <li class="MainDataLeft">商户简介</li>
                <li class="MainDataRight" v-text="datas.business.intro"></li>
              </ul>
              <ul class="MainData" v-if="datas.business.customize_data" v-for="val in datas.business.customize_data">
                <li class="MainDataLeft" v-text="val.key" v-if="val.key != '经纬度'"></li>
                <li class="MainDataRight" v-text="val.value" v-if="val.key != '经纬度'"></li>
              </ul>
            </div>
          </div>

          <!-- 质检信息 -->
          <div class="MainBox" v-if="datas.batch && datas.batch_is_show == 1 && datas.batch.qc">
            <div class="MainTitle">质检信息</div>
            <div class="MainDatasBox">
              <ul class="MainData" v-for="(item, index) in datas.batch.qc" v-bind:key="index">
                <li class="MainDataLeft" v-text="item.key"></li>
                <li class="MainDataRight" v-text="item.value" v-if="item.ix == 0"></li>
                <li class="MainDataRight MainDataRightImg backImg" v-else
                  :style="{ backgroundImage: 'url(' + item.value + ')' }"><img class="OpacityImg" :src="item.value">
                </li>
              </ul>
            </div>
          </div>

          <!-- 生产流程 -->
          <div id="trace-box" class="MainBox" v-if="datas.process && datas.process_is_show == 1">
            <div class="MainTitle">生产流程</div>
            <div class="MainDatasBox">
              <ul class="MainData TraceData" v-for="(item, index) in datas.process" v-bind:key="index">
                <i class="TraceDataDotBox"><i class="TraceDataDot"></i></i>

                <i class="TraceDataDotBox TraceDataDotBottomBox" v-if="index == datas.process.length - 1"><i
                    class="TraceDataDot"></i></i>

                <i class="TraceDataLine"></i>
                <li class="MainDataLeft">
                  <p v-text="item.name"></p>
                  <p class="MainDataHint" v-text="item.date.substring(0, 10)"></p>
                </li>
                <li class="MainDataRight MainDataRightImg backImg"
                  :style="{ backgroundImage: 'url(' + item.icon + ')' }">
                  <img class="OpacityImg" :src="item.icon">
                </li>
              </ul>
            </div>
          </div>

          <!-- 生产流程演示 -->
          <div id="trace-box" class="MainBox"
            v-if="datas.process_demo && datas.process_demo.length > 0 && datas.process_demo_is_show == 1">
            <div class="MainTitle">生产流程</div>
            <div class="MainDatasBox">
              <ul class="MainData TraceData" v-for="(item, index) in datas.process_demo" v-bind:key="index">
                <i class="TraceDataDotBox"><i class="TraceDataDot"></i></i>

                <i class="TraceDataDotBox TraceDataDotBottomBox" v-if="index == datas.process_demo.length - 1"><i
                    class="TraceDataDot"></i></i>

                <i class="TraceDataLine"></i>
                <li class="MainDataLeft">
                  <p v-text="item.name"></p>
                  <p class="MainDataHint" v-text="item.date"></p>
                </li>
                <li class="MainDataRight MainDataRightImg backImg"
                  :style="{ backgroundImage: 'url(' + item.icon + ')' }">
                  <img class="OpacityImg" :src="item.icon">
                </li>
              </ul>
            </div>
          </div>

          <!-- 经销商流程 -->
          <div id="trace-box" class="MainBox" v-if="datas.dealer && datas.dealer_is_show == 1">

            <!-- 北京华千新技术有限公司 定制头部标题 -->
            <div v-if="datas.business.rootid == 100010094" class="MainTitle">发往城市</div>
            <div v-else class="MainTitle">经销商流程</div>

            <div class="MainDatasBox">
              <ul class="MainData TraceData" v-for="(item, index) in datas.dealer" v-bind:key="index">
                <i class="TraceDataDotBox"><i class="TraceDataDot"></i></i>

                <i class="TraceDataDotBox TraceDataDotBottomBox" v-if="index == datas.dealer.length - 1"><i
                    class="TraceDataDot"></i></i>

                <i class="TraceDataLine"></i>
                <li class="MainDataLeft">
                  <p v-text="item.name"></p>
                  <p class="MainDataHint" v-text="item.date.substring(0, 10)"></p>
                </li>
                <li class="MainDataRight MainDataRightImg backImg"
                  :style="{ backgroundImage: 'url(' + item.icon + ')' }">
                  <img class="OpacityImg" :src="item.icon">
                </li>
              </ul>
            </div>
          </div>

          <!-- 经销商详情 AND 北京华千新技术有限公司不显示 -->
          <div id="business-box" class="MainBox" v-if="datas.dealer && datas.dealer_is_show == 1 && datas.business.rootid != 100010094">
            <div class="MainTitle">经销商详情</div>

            <div class="MainDatasBox">
              <div class="MainDatasLine" v-for="(item, index) in datas.dealer" v-bind:key="index">
                <ul class="MainData">
                  <li class="MainDataLeft">名称</li>
                  <li class="MainDataRight" v-text="item.name"></li>
                </ul>
                <ul class="MainData">
                  <li class="MainDataLeft">联系人</li>
                  <li class="MainDataRight" v-text="item.linkman"></li>
                </ul>
                <ul class="MainData">
                  <li class="MainDataLeft">联系电话</li>
                  <li class="MainDataRight" v-text="item.linkphone"></li>
                </ul>
                <ul class="MainData">
                  <li class="MainDataLeft">联系地址</li>
                  <li class="MainDataRight" v-text="item.linkaddress"></li>
                </ul>
              </div>
            </div>
          </div>

          <!-- 视频信息 -->
          <div id="video-box" class="MainBox" v-if="datas.video && datas.video_is_show == 1">
            <div class="MainTitle">视频信息</div>
            <div class="MainDatasBox">
              <video id="VideoBox" class="video-js vjs-big-play-centered vjs-fluid VideoBox"
                :poster="datas.video.url + '?vframe/jpg/offset/1/w/400/'">
                <source :src="datas.video.url" type="video/mp4">
              </video>
            </div>
          </div>

          <!-- 自定义栏目 -->
          <div id="ref-box" class="MainBox" v-if="datas.ref && datas.ref_is_show == 1"
            v-for="(item, index) in datas.ref" v-bind:key="index">
            <div class="MainTitle" v-text="item.name"></div>
            <ul class="MainRefDatasBox">
              <li v-for="(val, ix) in item.datas" v-bind:key="ix">
                <p class="MainRefDatasTxt" v-if="val.type == 0" v-text="val.data"></p>
                <img v-else :src="val.data">
              </li>
            </ul>
          </div>

          <!-- 自定义底部菜单 -->
          <div id="menu-box" class="MainBox MainMenuBox" v-if="datas.menu && datas.menu_is_show == 1">
            <ul class="MainMenuRow CliclStyle" v-for="(item, index) in datas.menu" v-bind:key="index"
              @click="ClickMenu(item)">
              <li class="MainMenuIcon">
                <i v-if="item.icon" class="backImg" :style="{ backgroundImage: 'url(' + item.icon + ')' }"></i>
                <i v-else class="backImg"
                  :style="{ backgroundImage: 'url(../../static/images/icon' + item.type + '.png)' }"></i>
                <span class="icon iconfont iconyou MainMenuArrows"></span>
              </li>
              <li class="MainMenuDatas">
                <p class="MainMenuDatasTit onlyOneRow" v-text="item.name"></p>
                <p class="MainMenuDatasTxt onlyOneRow" v-text="item.describe"></p>
              </li>
            </ul>
          </div>

          <!-- 模块索引 -->
          <div class="ModuleIndex" v-if="datas.module_index_is_show == 1">
            <ul>
              <li v-for="item in ModulList" @click="ClickModul(item.id)">
                <div v-text="item.name"></div>
              </li>
            </ul>
          </div>

        </viewer>

        <!-- 提示框 -->
        <section id="MaskedBlock" v-if="hintTxt">
          <i class="Masked"></i>
          <div class="ToolTip">
            <ul>
              <li>{{ datas.business.name }}</li>
              <li class="MaskedMain" v-text="hintTxt"></li>
              <li class="confirm" v-on:click="CloseTip">确定</li>
            </ul>
          </div>
        </section>

      </section>

    </div>
  </div>
</template>

<script>
let self, map;
import axios from 'axios'
import Swiper from 'swiper'
import Loading from '@/components/Loading.vue'
import Music from '@/components/Music.vue'
export default {
  name: 'Normal04',
  components: {
    'K-Loading': Loading,
    'K-Music': Music
  },
  data() {
    return {
      code: null,
      vcode: null,
      count: 2,
      banner: ["banner01.png", "banner02.png", "banner03.png"],
      datas: null,
      hintTxt: null,
      Loading: {
        type: 1,
        txt: "数据请求中..."
      },
      Music: {
        url: null,
        type: false
      },
      location: null,
      ModulList: [{
        id: "business-box",
        name: "商户"
      }, {
        id: "trace-box",
        name: "溯源"
      }, {
        id: "video-box",
        name: "视频"
      }, {
        id: "ref-box",
        name: "推荐"
      }, {
        id: "menu-box",
        name: "菜单"
      }]
    }
  },
  created() {
    self = this;
    document.querySelector('body').setAttribute('style', 'background-color:#2536e8');

    //判断是演示还是真实码标
    if (this.$route.query.type == "demo") {
      self.GetDemoDatas(this.$route.query.pid, this.$route.query.rid);  //获取演示模板信息
    } else {
      self.code = self.GetCode();
      self.GetDatas();  //获取码标信息
    }
  },
  updated() {
    var banner = new Swiper('.banner', {
      autoplay: 3000,//可选选项，自动滑动
      pagination: '.swiper-pagination',
      paginationType: 'progress',
      loop: true,
    })

    if (self.datas.video) {
      self.initVideo();
    }

    self.CreateMap();
  },
  methods: {
    GetDemoDatas(pid, rid) {
      axios.get(self.GetServerUrl(1) + "template_product/" + pid + "/" + rid)
        .then(function (response) {
          let datas = response.data.meta;
          let defaultDatas = JSON.parse(datas.default_basic.config_value);  //初始化默认信息
          console.log(datas)
          if (datas.scan_count) {
            datas.scan_count = datas.scan_count;
          } else {
            datas.scan_count = 1;
          }
          datas.scan_first_time = "2017-10-31 12:12";
          datas.scan_first_address = "广东省深圳市";
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          } else {
            if (defaultDatas.ref) {
              datas.ref = JSON.parse(defaultDatas.ref);
            }
          }
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          if (datas.batch) {
            datas.batch = JSON.parse(datas.batch);
            datas.batch.qc = JSON.parse(datas.batch.qc);
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;

          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }

          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }

          //默认信息
          if (!datas.process) {
            datas.process = defaultDatas.process;
          }
          if (!datas.process_demo) {
            datas.process_demo = defaultDatas.process_demo;
          }
          if (!datas.dealer) {
            datas.dealer = defaultDatas.dealer;
          }
          self.datas = datas;

          // document.title = self.datas.business.name;  //设置页面标题
        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    },
    GetDatas() {
      axios.get(self.GetServerUrl(1) + "query/" + self.code)
        .then(function (response) {

          let datas = response.data.meta.product_template;
          datas.scan_count = response.data.meta.scan_count;  //扫码次数
          datas.scan_first_time = response.data.meta.scan_first_time;  //扫码时间
          datas.scan_first_address = response.data.meta.scan_first_address;  //扫码地点
          datas.verify = response.data.meta.verify; //防伪码

          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);

            if (datas.business.customize_data) {
              for (let i in datas.business.customize_data) {
                if (datas.business.customize_data[i].key == "经纬度") {
                  self.location = datas.business.customize_data[i].value;
                }
              }
            }

          }
          //自定义防伪查询语句
          if(datas.first_antifake_msg){
            self.msg = datas.first_antifake_msg;
          }
          //自定义属性
          if (response.data.meta.activation_a) {
            datas.attribute = JSON.parse(response.data.meta.activation_a);
          }
          //焦点图
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          //自定义栏目
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          }
          //自定义菜单
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }
          //批次信息
          if (datas.batch) {
            if (datas.batch.qc) {
              datas.batch.qc = JSON.parse(datas.batch.qc);
            }
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);

            //自动转换新域名
            // if(datas.video.url){
            //   let videoUrl = datas.video.url.substring(12,17);
            //   if(videoUrl == "wwmxt"){
            //     datas.video.url = self.GetVideoUrl() + datas.video.url.substring(20,datas.video.url.length)
            //   }
            // }

          }
          datas.activity_is_show = 1;
          self.datas = datas;

          // document.title = self.datas.business.name;  //设置页面标题
        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    },
    initVideo() {
      //初始化视频方法
      let myPlayer = this.$video(VideoBox, {
        controls: true,  //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
        autoplay: false,  //自动播放属性,muted:静音播放
        preload: "auto",  //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
      });
    },
    ViewMore(datas) {
      if (self.code) {
        this.$router.push({ path: "/ScanCodeRecord" }); // 模板路由跳转
      } else {
        alert("真实码标数据才能查看扫码记录！");
      }
    },
    inited(viewer) {
      self.$viewer = viewer
    },
    PreviewImgs() {
      self.$viewer.show();
      self.$viewer.update();
    },
    ClickMenu(data) {
      if (data.type != 2) {
        window.location.href = data.url;
      } else {
        this.$router.push({ path: "/qr?qr=" + data.qr });
      }
    },
    ClickModul(id) {
      if ($("#" + id).offset()) {
        let top = $("#" + id).offset().top;
        $("html,body").animate({ scrollTop: top - 15 }, 300);
      }
    },
    CreateMap() {
      if (self.location) {
        let ll = self.location.split(",");
        map = new BMap.Map("map"); // 创建Map实例
        var point = new BMap.Point(ll[0], ll[1]);
        var marker = new BMap.Marker(point);
        let left = self.datas.business.name.length * 6;
        var label = new BMap.Label(self.datas.business.name, { offset: new BMap.Size('-' + left, 26) });
        label.setStyle({
          color: "black",
          border: '0px',
          fontSize: "12px",
          height: "20px",
          padding: "0 10px",
          lineHeight: "20px",
          fontFamily: "微软雅黑"
        });
        marker.setLabel(label);
        map.addOverlay(marker);
        map.centerAndZoom(point, 13); // 初始化地图,设置中心点坐标和地图级别
        map.addControl(new BMap.MapTypeControl()); //添加地图类型控件
        map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
      }
    },
    CodeVerify() {
      axios.get(self.GetServerUrl(1) + "queryVerify/" + self.code + "/" + self.vcode)
        .then(function (response) {
          var json = response.data;
          if (json.code == 200) {
            self.isShow = true;
            self.hintTxt = `您所查询的是 ${self.datas.business.name} 正品，当前查询次数为 ${json.meta.query_count} 次，感谢查询 ！`;
            if(json.meta.query_count === 1 && self.msg){
              self.hintTxt = self.msg;
            }
          } else {
            self.isShow = false;
          }
        }).catch(function (error) {
          self.hintTxt = "防伪码错误！";
          self.isShow = false;
          self.vcode = '';
        })
    },
    CloseTip() {
      self.hintTxt = null;
    }
  }
}
</script>

<style scoped>
.box {
  padding-bottom: 40px;
}

.banner {
  overflow: hidden;
}

.banner img {
  display: block;
  width: 100%;
}

.bannerbox {
  border-radius: .25rem;
  overflow: hidden;
}

.bannerbox img {
  display: block;
  width: 100%;
}

.MainOidBox {
  padding: .6rem;
  padding-bottom: 0;
}

.MainOidBox ul {
  padding: .6rem;
  text-align: center;
  color: #fff;
  font-size: .6rem;
  font-weight: bold;
  background-image: url(../../static/images/Normal04/box.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.MainOidBox ul li {
  margin-top: 5px;
}

.MainOid {
  font-size: .65rem;
}

.MainBox {
  overflow: hidden;
  border-radius: .25rem;
  margin: .6rem;
  color: #fff;
  background-color: rgba(255, 255, 255, 0.15);
  box-shadow: 0 0 5px rgba(100, 100, 100, 0.2);
}

.MainTitle {
  font-size: .58rem;
  padding: .6rem;
  border-radius: .25rem .25rem 0 0;
  background-color: rgba(255, 255, 255, 0.1);
  font-weight: 600;
  letter-spacing: .05rem;
}

.MainDatasBox {
  font-size: .58rem;
  padding: 0 .6rem;
  padding-bottom: 0.6rem;
  word-wrap: break-word;
}

.MainData {
  line-height: .7rem;
  padding-top: .6rem;
  padding-bottom: .2rem;
  position: relative;
}

.MainDatasLine {
  padding: 10px 0 20px 0;
  border-top: 1px dashed #FFF;
}

.MainDatasLine:first-child {
  border: 0;
}

.MainData:after {
  display: block;
  clear: both;
  content: '';
  visibility: hidden;
  height: 0;
}

.MainData:last-child {
  padding-bottom: 0;
}

.MainDataLeft {
  width: 5rem;
  float: left;
}

.MainDataRight {
  width: calc(100% - 5rem);
  float: right;
  text-align: right;
}

.MainDataRightImg {
  width: 7rem !important;
  height: 4rem;
  overflow: hidden;
}

.MainDataHint {
  margin-top: .1rem;
  color: #fff;
  font-size: .55rem;
}

/* 溯源信息 */
.TraceData {
  padding-left: 1rem;
  padding-top: 0;
  padding-bottom: 1rem;
}

.TraceData:first-child {
  margin-top: .6rem;
}

.TraceDataDotBox {
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: .45rem;
  height: .7rem;
  background-color: #2C5DE8;
  z-index: 99;
}

.TraceDataDot {
  display: block;
  position: absolute;
  width: .3rem;
  height: .3rem;
  margin-top: .12rem;
  border: 2px solid #fff;
  border-radius: .3rem;
  z-index: 99;
}

.TraceDataDotBottomBox {
  top: auto;
  bottom: 0;
}

.TraceDataLine {
  display: block;
  position: absolute;
  top: .2rem;
  left: .186rem;
  bottom: 0;
  border-left: 2px dashed #fff;
  z-index: 98;
}

.VideoBox {
  margin-top: .6rem;
  width: 100%;
}

.MainRefDatasBox {
  padding: .6rem;
}

.MainRefDatasBox li:first-child {
  margin-top: 0;
}

.MainRefDatasBox li {
  line-height: .9rem;
  font-size: .58rem;
  margin-top: .3rem;
}

.MainRefDatasBox li img {
  display: block;
  width: 100%;
}

.MainRefDatasTxt {
  text-indent: .8rem;
}

.MainMenuRow {
  padding: .5rem;
  overflow: hidden;
  position: relative;
  border-bottom: 1px solid #F3F3F3;
}

.MainMenuRow:last-child {
  border-bottom: 0;
}

.MainMenuIcon {
  float: left;
  width: 2.2rem;
  height: 2.2rem;
  background-color: #5865ed;
  margin-right: .5rem;
  border-radius: .2rem;
}

.MainMenuIcon i {
  display: block;
  width: 1.4rem;
  height: 1.4rem;
  margin: .4rem;
}

.MainMenuDatas {
  float: left;
  width: calc(100% - 3.5rem);
}

.MainMenuDatasTit {
  margin-top: .1rem;
  font-size: .58rem;
}

.MainMenuDatasTxt {
  font-size: .55rem;
  color: #FFF;
  margin-top: .15rem;
}

.MainMenuArrows {
  position: absolute;
  right: .5rem;
  top: calc(50% - .4rem);
  color: #fff;
  font-size: .55rem;
}

.CliclStyle:active {
  background: #F6F6F6;
}

.CliclStyle:focus {
  background: #FFF;
}

#map {
  height: 300px;
  opacity: 0.7;
}

.proimg {
  width: 100%;
  display: block;
  margin-top: 10px;
}

.ModuleIndex {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  color: #fff;
  z-index: 99;
  background-color: rgba(69, 84, 235, 0.98);
  box-shadow: 0 0 5px rgba(255, 255, 255, 0.1);
}

.ModuleIndex ul {
  overflow: hidden;
  padding: 12px 0;
}

.ModuleIndex ul li {
  float: left;
  font-size: 15px;
  text-align: center;
  width: 20%;
}
.inputBox{
  background: rgba(255, 255, 255, 0.8);
}
</style>



// WEBPACK FOOTER //
// src/view/Normal04.vue